import {Injectable} from "@angular/core";
import {HttpRepository} from "./http.repository";
import {PagingRequest} from "../interfaces/rest/paging/PagingRequest";
import {Observable} from "rxjs";
import {PagedData} from "../interfaces/rest/paging/PagedData";
import {GlobalConfig} from "../configs/GlobalConfig";
import {Remedy} from "../interfaces/rest/Remedy";
import {UserTokensRepository} from "./user-tokens.repository";

@Injectable()
export class RemedyRepository {

    constructor(protected httpRepository: HttpRepository,
                protected userTokensRepository: UserTokensRepository) {

    }

    getRemediesWithPaging(pagingRequest: PagingRequest, excludeRichText: boolean = false): Observable<PagedData> {
        return this.httpRepository.post(`${GlobalConfig.endpoints.remedies}/paging?excludeRichText=${excludeRichText}`, pagingRequest);
    }

    getRemedy(remedyId: number, langCode = 'en'): Observable<Remedy> {
        return this.httpRepository.get(`${GlobalConfig.endpoints.remedies}/${remedyId}?languageCode=${langCode}`);
    }

    createRemedy(remedy: Remedy): Observable<Remedy> {
        return this.httpRepository.post(`${GlobalConfig.endpoints.remedies}`, remedy);
    }

    updateRemedy(remedy: Remedy): Observable<Remedy> {
        return this.httpRepository.put(`${GlobalConfig.endpoints.remedies}/${remedy.remedyId}`, remedy);
    }

    deleteRemedy(remedyId: number) {
        return this.httpRepository.delete(`${GlobalConfig.endpoints.remedies}/${remedyId}`);
    }

    getRemedyByAlertRule(alertRuleId: string): Observable<Remedy> {
      return  this.httpRepository.get(`${GlobalConfig.endpoints.remedies}/alertRuleId?alertRuleId=${alertRuleId}`);
    }
}
